import { Skeleton } from 'aui';
import classNames from "clsx";
import React from "react";

interface IProps {
  [key: string]: any;
}
const SpinBlock: React.FC<IProps> = (props) => {
  const { className } = props;
  return <div {...props} className={classNames(className, 'flex p-12 items-center justify-center')}>
    <Skeleton active />
  </div>;
}

export default SpinBlock;
